import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { TableElementComponent } from '@uranda/ui';
import { LeadAssignmentStatusEnum } from '../../../../models/lead-assignment-status.enum';

@Component({
  selector: 'app-countdown-badge-table',
  templateUrl: './countdown-badge-table.component.html',
  styleUrls: ['./countdown-badge-table.component.css'],
  standalone: false,
})
export class CountdownBadgeTableComponent
  extends TableElementComponent
  implements OnInit, OnDestroy
{
  @Input() status: string = '';
  @Input() textOnly: boolean = false;

  countdownLabel?: string;
  private intervalId: any;
  countdownClass: string = '';
  @Input() override show: boolean = false;
  @Input() request?: any;

  override ngOnInit(): void {
    super.ngOnInit();
    if (this.data) {
      this.request = this.data;
    }
    this.status = this.request.status;
    this.show =
      this.status == LeadAssignmentStatusEnum.ACCEPTED ||
      this.status == LeadAssignmentStatusEnum.PENDING ||
      this.status == LeadAssignmentStatusEnum.INTERESTED;
    this.updateCountdownLabel();
    this.intervalId = setInterval(() => this.updateCountdownLabel(), 1000);
  }

  updateCountdownLabel(): void {
    const expiration = new Date(this.request.expiresAt);
    const now = new Date();
    const diffMs = expiration.getTime() - now.getTime();

    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
    const diffSeconds = Math.floor((diffMs % (1000 * 60)) / 1000);

    const formattedHours = String(diffHours).padStart(2, '0');
    const formattedMinutes = String(diffMinutes).padStart(2, '0');
    const formattedSeconds = String(diffSeconds).padStart(2, '0');

    if (diffMs <= 0) {
      this.countdownLabel = undefined;
      this.countdownClass = '';
    } else if (diffHours <= 8) {
      this.countdownLabel = `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
      this.countdownClass = 'bg-danger text-white';
    } else {
      this.countdownLabel = `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
      this.countdownClass = 'text-dark';
    }
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
